import { featureFlagControllerVerifyFeatureAvailability } from '@/generated/korza-api-client';
import type { FeatureFlagResponseDto } from '@/generated/korza-api-client/types.gen';
import { useQuery } from '@tanstack/react-query';
import { useTenant } from './use-tenant';

export function useFeatureFlags() {
  const tenant = useTenant();

  return useQuery<FeatureFlagResponseDto>({
    queryKey: ['feature-flags', tenant.slug],
    queryFn: async () => {
      const res = await featureFlagControllerVerifyFeatureAvailability({
        path: { tenantSlug: tenant.slug },
        throwOnError: true,
      });
      return res.data;
    },
  });
}
